import React, { FC, ReactElement, ReactNode } from 'react'

interface RepeatProps {
  n: number
  children: ReactNode
  wrapper?: ReactElement
}

const Repeat: FC<RepeatProps> = ({ n, children, wrapper }) => {
  const repeatedElements = Array.from({ length: n }).map((_, index) => (
    <React.Fragment key={String(index + 1)}>
      {children}
    </React.Fragment>
  ))

  if (wrapper) {
    return React.cloneElement(wrapper, { children: repeatedElements })
  }

  return <>{repeatedElements}</>
}

export default Repeat
